export function getCursorProps(props) {
    if (props.pointer)
        props.cursor = 'pointer';
    return {
        classes: {},
        props: {},
        styles: {
            cursor: props.cursor || undefined
        },
        variables: {}
    };
}
